import * as core from '../../../../../../../core'

import { query } from './ideas-table.query'

export const RESOURCE = {
  payload: {
    alias: 'ideas.table',
    description:
      'Reduced table used to display and explore innovation ideas on dashboard',
    name: 'Ideas Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
